(function() {
  var __blocks__ = {};
  (function() {
    var element = document.getElementById("blocks-script");
    var attribute = a = element ? element.getAttribute("data-blocks") : '';
    var blocks = a.split(",").filter(Boolean);

    for (var i = 0; i < blocks.length; i++) {
      __blocks__[blocks[i]] = true;
    }
  })();
  (function() {
  if (!__blocks__["shoppable-video"] && !Shopify.designMode) return;
  try {
    // Shopify bundles block scripts once. Load the feature only when its markup
  // exists, including first insertion through the editor or section rendering.
  const observer = new MutationObserver(loadShoppableVideo);
  function loadShoppableVideo() {
    if (!document.querySelector('shoppable-video-component')) return;
    observer.disconnect();
    import('@theme/shoppable-video').catch((error) => console.error(error));
  }
  if (document.querySelector('shoppable-video-component')) {
    loadShoppableVideo();
  } else {
    observer.observe(document.documentElement, { childList: true, subtree: true });
  }
  } catch(e) { console.error(e); }
})();

})();
